import React from "react";
import styles from "./LeftContentRightImage.module.css";
import PricingHero from "./PricingHero";
import GifImageSlider from "./GifImageSlider";

const LeftContentRightImage = ({ setIsRegisterOpen }) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        
        {/* LEFT CONTENT */}
        <div className={styles.content}>
          <PricingHero />
          <button 
            className={styles.ctaButton}
            onClick={() => setIsRegisterOpen(true)}
          >
            Register Now
          </button>
        </div>

        {/* RIGHT IMAGE SLIDER */}
        <div className={styles.imageBox}>
          <GifImageSlider />
        </div>

      </div>
    </section>
  );
};

export default LeftContentRightImage;